<template>
  <Head title="Playbook Preview" />
  
  <AppLayout>
    <div id="playbook-optin" class="container-fluid d-flex flex-column full-body-height">
      <div class="row justify-content-center mx-4 flex-grow-1">
        <div class="col-12 px-0 d-flex align-items-center justify-content-center">
          <div class="card playbooks-background w-100">
            <div class="card-body d-flex align-items-center justify-content-center full-body-height">
              <div class="col-lg-6 col-md-8 col-12 px-3">
                <div class="static-page-header mb-5 text-center">
                  <img src="/img/images/playbooks-static-heading.svg">
                </div>

                <h2 class="text-center fw-medium">Speed and strategy, <span class="text-playbook-color">finally in sync.</span></h2>

                <div class="my-4">
                  <p class="mb-3"> Build, test, and get launch-ready in minutes. Avid learns your tone, sharpens your message, and improves every campaign over time. Playbooks are available at no cost during the Early Access period as we continue expanding features and refining based on real-world use. </p>
                  <p class="mb-3"> Powered by insights from 9,000+ fundraising experiments and 650 million donor interactions, Playbooks don't just look good—they're built to perform. Each campaign is custom-built for your nonprofit, tailored to your mission, and optimized to deliver real results.</p>
                </div>

                <div class="mt-5 mb-3 text-center">
                  <button type="button" @click="goBack" class="btn btn-secondary">Not Now</button>
                  <button type="button" @click="showPlaybookWalkthrough" class="btn btn-primary ms-3">Get Started</button>
                </div>

                <p class="text-muted text-center">
                  <small>Join the Early Access and see how fundraisers are already raising more with less.</small>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <playbook-walk-through-slider 
        ref="walkthroughSlider"
        :show="false" 
        :client-url="client.url">
      </playbook-walk-through-slider>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head, Link, router } from '@inertiajs/vue3';
import AppLayout from '../../Layouts/AppLayout.vue';

const props = defineProps({
  client: Object
});

// Set window globals immediately for legacy component compatibility
window.__CLIENT__ = props.client;

const showPlaybookWalkthrough = () => {
  const event = new CustomEvent('show-walkthrough');
  window.dispatchEvent(event);
};

const goBack = () => {
  if (window.history.length > 1) {
    window.history.back();
  } else {
    // Fallback to landing page if no history
    router.visit(`/landing/${props.client.url}`);
  }
};
</script>

